import { useCallback } from 'react';
import type { ShadowsHighlightsValue } from '../../lib/adjustments/shadows-highlights';
import { RangeRow } from './RangeRow';
import type { AdjustmentPanelProps } from './registry';

export function ShadowsHighlightsPanel({
  value,
  onChange,
}: AdjustmentPanelProps<ShadowsHighlightsValue>) {
  const set = useCallback(
    (patch: Partial<ShadowsHighlightsValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-4">
      <fieldset className="space-y-2">
        <legend className="text-[11px] font-medium uppercase text-muted-foreground tracking-wide mb-1">
          Shadows
        </legend>
        <RangeRow
          label="Amount"
          min={-100}
          max={100}
          step={1}
          value={value.shadowsAmount}
          onChange={(v) => set({ shadowsAmount: v })}
        />
        <RangeRow
          label="Tonal Width"
          min={0}
          max={100}
          step={1}
          value={value.shadowsTonalWidth}
          onChange={(v) => set({ shadowsTonalWidth: v })}
        />
      </fieldset>

      <fieldset className="space-y-2">
        <legend className="text-[11px] font-medium uppercase text-muted-foreground tracking-wide mb-1">
          Highlights
        </legend>
        <RangeRow
          label="Amount"
          min={-100}
          max={100}
          step={1}
          value={value.highlightsAmount}
          onChange={(v) => set({ highlightsAmount: v })}
        />
        <RangeRow
          label="Tonal Width"
          min={0}
          max={100}
          step={1}
          value={value.highlightsTonalWidth}
          onChange={(v) => set({ highlightsTonalWidth: v })}
        />
      </fieldset>
    </div>
  );
}
